/* eslint-disable @typescript-eslint/no-unused-expressions */
import React from "react";
import { Divider, Typography } from "antd";
import { Accordion, AccordionTab } from "primereact/accordion";

const { Text } = Typography;

interface HelpAccordionProps {
  title: string;
  children: React.ReactNode;
}

const AccordionSection = ({ title, children }: HelpAccordionProps) => {
  return (
    <Accordion multiple className="mb-6">
      <AccordionTab
        header={<Text strong>{title}</Text>}
        className="rounded-lg"
      >
        <Divider className="my-3" />
        <div className="space-y-4">{children}</div>
      </AccordionTab>
    </Accordion>
  );
};

export default AccordionSection;
